import { all, put, call, takeEvery, takeLatest } from "redux-saga/effects";
import api_service from "../../network/api_callbacks";
import {
    GET_USER_REQUEST,
    getUserSuccess,
    getUserFailure
} from "../actions/getUser"

function* getUserSaga(action) {
    console.log(action)
    try {
        const response = yield call(api_service.getUser, action.payload);
        yield put(getUserSuccess(response));
    } catch (err) {
        console.log(err);
        yield put(getUserFailure(err.response?.data?.message || 'failed'));
    }
}

export default function* watchGetUserSaga() {
    yield takeEvery(GET_USER_REQUEST, getUserSaga);
}
